import React, { useState, useEffect } from "react";
import { Card, CardContent } from "../components/ui/Card.jsx";
import BloombergNews from "../components/ui/Headlines.jsx";
import LinkedInPost from "../components/ui/LinkedInPost";
import ClockCalendar from "../components/ui/ClockCalendar";
import LiveBadge from "../components/ui/LiveBadge.jsx";

const YouTubeLive = () => {
  return (
    <Card className="col-span-1">
      <CardContent className="p-4">
        <div className="flex justify-start">
          <LiveBadge />
        </div>
        <div className="mt-4">
          <iframe
            width="100%"
            height="434"
            src="https://www.youtube.com/embed/iEpJwprxDdk?autoplay=1&mute=1"
            title="YouTube Live Stream"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </CardContent>
    </Card>
  );
};

// 🔹 Composant principal du Dashboard
const Dashboard = () => {
  return (
    <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-6 z-10">
      {/* Bloc Date */}
      <Card className="col-span-1">
        <CardContent>
          <ClockCalendar />
        </CardContent>
      </Card>

      {/* Bloc YouTube Live (remplace les cotations) */}
      <YouTubeLive />

      {/* Bloc LinkedIn */}
      <Card className="col-span-1">
        <CardContent>
          <LinkedInPost />
        </CardContent>
      </Card>

      {/* Bloc Bloomberg News */}
      <Card className="col-span-1">
        <CardContent className="p-4 overflow-y-auto">
          <BloombergNews />
        </CardContent>
      </Card>
    </div>
  );
};

export default Dashboard;
